/* eslint-disable import/no-anonymous-default-export */
import apiClient from "../redux/ApiClient";

export default {
  //paygram Agents
  fetchAgents(rowsPerPage, page) {
    return apiClient.get(`/agents/view?rows=${rowsPerPage}&page=${page}`);
  },
};
